import React from "react";
import { getCurrentUser } from "../../lib/auth_base/localstorage";

import PageTop from "../../ui/page-top";
import LoginForm from "./ui/LoginForm";

//
export default  function Login() {
  const user = getCurrentUser();

  return (
    <React.Fragment>
      <PageTop
        is_logged={user ? true : false}
        page={{ title: "Login", bg_color: "sky" }}
      />
      <div className="login-cover">
        <div className="login-pane">
          <LoginForm />
        </div>
      </div>
    </React.Fragment>
  );
}
